import { useEffect, useRef } from 'react'

import { useTranslation } from 'react-i18next'
import {
    useQueryClient
} from 'react-query'
import { useSearchParams } from 'react-router-dom'


import { addToast } from 'components/Toast/Toast'
import { useLoadingContext } from 'context/loadingContext'
import { verifyMyAgeCallback } from 'services/endpoints/verify'
import { useUserProfile } from 'store'
import { type IIdentityVerificationCallbackParams } from 'types/interfaces/IIdentityCallbackVerificationParams'

export const VerifyMyAgeCallback = () => {
    const { handleGlobalLoading } = useLoadingContext()
    const [searchParams] = useSearchParams()
    const { t } = useTranslation()
    const user = useUserProfile()
    const timeoutRef = useRef<NodeJS.Timeout>()
    const queryClient = useQueryClient()
    
    const killRedirectTimer = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }
    }

    useEffect(() => {
        return () => {
            killRedirectTimer()
        }
    }, [])

    const vmaErrorFn = () => {
        addToast('error', t('error:anErrorOccuredPleaseTryAgain'), 7000, true)

        killRedirectTimer()
        timeoutRef.current = setTimeout(() => {
            if (user) {
                window.location.replace(
                    `${process.env.PUBLIC_URL}/become-a-creator`
                )
            } else {
                window.location.replace(`${process.env.PUBLIC_URL}/auth`)
            }
        }, 7000)
    }

    const checkQueryParams = async (
        queryParams: IIdentityVerificationCallbackParams
    ) => {
        try {
            await verifyMyAgeCallback(queryParams);
            await queryClient.invalidateQueries(['userProfile']); // This triggers a refetch!
            window.location.replace(
                `${process.env.PUBLIC_URL}/become-a-creator`
            );
        } catch (err) {
            vmaErrorFn();
        }
    };


    useEffect(() => {
        const queryParams = Object.fromEntries(
            searchParams
        ) as unknown as IIdentityVerificationCallbackParams

        handleGlobalLoading(true)

        checkQueryParams(queryParams)
    }, [])

    return <></>
}
